import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, RegenerateEventQrDto } from "@mimber/schema"
import { eventsKeys } from "../events.utils"

export const useRegenerateEventQr = (
  eventUuid: string,
  options?: UseMutationOptions<ResponseDto<RegenerateEventQrDto>, Error, void>
): UseMutationResult<ResponseDto<RegenerateEventQrDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useRegenerateEventQr")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<RegenerateEventQrDto>>(
        `events/${eventUuid}/attendance/regenerate-qr`
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findOne(eventUuid),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
